import request from '@/utils/request';


/**
 * 业绩列表
 * @param { page: 页码, count: 一页显示多少条, startTime: 日期开始时间, endTime: 日期结束时间 } data 
 */
export function achievementList(data) {
  return request({
    url: '/achievement/list',
    method: 'post',
    data
  });
}
/**
 * 团队业绩提成
 * @param { orderId: 订单id } data 
 */
export function teamAchievement(data) {
  return request({
    url: '/achievement/team-achievement',
    method: 'post',
    data
  });
}

/**
 * 业绩统计
 * @param { startTime: 开始时间, endTime: 结束时间 } data 
 */
export function countAchievement(data) {
  return request({
    url: '/achievement/count-achievement',
    method: 'post',
    data
  });
}